export const countryValidate = {
  ESP: /([A-Z]{1,2}\d{4}[A-Z]{2,3})|([A-Z]{1,2}\d{4}[A-Z]{2,3})|([A-Z]{2}\d{6})|(\d{4}[A-Z]{3})|(CD\d{4,5})|(CC\d{4,5})/g,
  DEFAULT: /([A-Z]{1,2}\d{4}[A-Z]{2,3})|([A-Z]{1,2}\d{4}[A-Z]{2,3})|([A-Z]{2}\d{6})|(\d{4}[A-Z]{3})|(CD\d{4,5})|(CC\d{4,5})/g,
  DEFAULT_VGR: /(E\d{4}[A-Z]{3})|([A-Z]{1,2}\d{4}[A-Z]{2})|(E[A-Z]{1,2}\d{6})|([CH]{1}\d{4}[A-Z]{1,3})|(CD\d{4,5})|(CC\d{4,5})/g
}
